module.exports = __webpack_public_path__ + "media/images/flags/1x1/atg-91a8f5b9335d21a1fa931a04a2067ca1.svg";